/*!
 * jquery.drawPieChart.js
 * Version: 0.3(Beta)
 * Inspired by Chart.js(http://www.chartjs.org/)
 *
 * Copyright 2013 hiro
 * https://github.com/githiro/drawPieChart
 * Released under the MIT license.
 */
;(function($, undefined) {
  $.fn.drawPieChart = function(data, options) {
    var $this = this,
        getID = $this.attr('id'),
        W = $this.width(),
        H = $this.height(),
        centerX = W/2,
        centerY = H/2,
        cos = Math.cos,
        sin = Math.sin,
        PI = Math.PI,
        settings = $.extend({
          segmentShowStroke : true,
          segmentStrokeColor : "#fff",
          segmentStrokeWidth : 1,
          baseColor: "#fff",
          baseOffset: 15,
          edgeOffset: 30,//offset from edge of $this
          pieSegmentGroupClass: "pieSegmentGroup",
          pieSegmentClass: "pieSegment",
          lightPiesOffset: 12,//lighten pie's width
          lightPiesOpacity: .3,//lighten pie's default opacity
          lightPieClass: "lightPie",
          animation : true,
          animationSteps : 90,
          animationEasing : "easeInOutExpo",
          //tipOffsetX: -15,
          //tipOffsetY: -45,
          //tipClass: "pieTip",
          beforeDraw: function(){  },
          afterDrawed : function(){  },
          onPieMouseenter : function(e,data){  },
          onPieMouseleave : function(e,data){  },
          onPieClick : function(e,data){  }
        }, options),
        animationOptions = {
          linear : function (t){
            return t;
          },
          easeInOutExpo: function (t) {
            var v = t<.5 ? 8*t*t*t*t : 1-8*(--t)*t*t*t;
            return (v>1) ? 1 : v;
          }
        },
        requestAnimFrame = function(){
          return window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            function(callback) {
              window.setTimeout(callback, 1000 / 60);
            };
        }();

    var $wrapper = $('<svg width="' + W + '" height="' + H + '" viewBox="0 0 ' + W + ' ' + H + '" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"></svg>').appendTo($this);
    var $groups = [],
        $pies = [],
        $lightPies = [],
        easingFunction = animationOptions[settings.animationEasing],
        pieRadius = Min([H/2,W/2]) - settings.edgeOffset,
        segmentTotal = 0;

    //Draw base circle
    var drawBasePie = function(){
      var base = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      var $base = $(base).appendTo($wrapper);
      base.setAttribute("cx", centerX);
      base.setAttribute("cy", centerY);
      base.setAttribute("r", pieRadius+settings.baseOffset);
      base.setAttribute("fill", settings.baseColor);
    }();

    //Set up pie segments wrapper
    var pathGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    var $pathGroup = $(pathGroup).appendTo($wrapper);
    $pathGroup[0].setAttribute("opacity",0);

    //Set up tooltip
    /*var $tip = $('<div class="' + settings.tipClass + '" />').appendTo('body').hide(),
      tipW = $tip.width(),
      tipH = $tip.height();*/

    for (var i = 0, len = data.length; i < len; i++){
      segmentTotal += data[i].value;
      var g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      g.setAttribute("data-order", i);
      g.setAttribute("data-system", getID == 'pieChart' ? 'doublesys':'singlesys');
      g.setAttribute("class", settings.pieSegmentGroupClass);
      $groups[i] = $(g).appendTo($pathGroup);
      $groups[i]
        .on("mouseenter", pathMouseEnter)
        .on("mouseleave", pathMouseLeave)
        .on("mousemove", pathMouseMove)
        .on("click", pathClick);

      var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      p.setAttribute("stroke-width", settings.segmentStrokeWidth);
      p.setAttribute("stroke", settings.segmentStrokeColor);
      p.setAttribute("stroke-miterlimit", 2);
      p.setAttribute("fill", data[i].color);
      p.setAttribute("class", settings.pieSegmentClass);
      $pies[i] = $(p).appendTo($groups[i]);

      var lp = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      lp.setAttribute("stroke-width", settings.segmentStrokeWidth);
      lp.setAttribute("stroke", settings.segmentStrokeColor);
      lp.setAttribute("stroke-miterlimit", 2);
      lp.setAttribute("fill", data[i].color);
      lp.setAttribute("opacity", settings.lightPiesOpacity);
      lp.setAttribute("class", settings.lightPieClass);


      $lightPies[i] = $(lp).appendTo($groups[i]);

      var text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      text.setAttribute('fill', '#fff');

      var t2 = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      t2.setAttribute('fill', '#fff');

      /* var t3 = document.createElementNS('http://www.w3.org/2000/svg', 'text');
         t3.setAttribute('fill', '#fff'); */


      if(getID == "pieChart"){
        if(i==0) {
          text.textContent = getMSG('system_memolife_05');
          text.setAttribute('x', '14em');
          text.setAttribute('y', '6em');
          t2.textContent = getMSG('system_memolife_06');
          t2.setAttribute('x', '14.2em');
          t2.setAttribute('y', '7em');
          t2.setAttribute('font-weight', 'bold');
        }
        if(i==1) {
          text.textContent = getMSG('system_memolife_07');
          text.setAttribute('x', '16em');
          text.setAttribute('y', '11.5em');
          t2.textContent = getMSG('system_memolife_08');
          t2.setAttribute('x', '18em');
          t2.setAttribute('y', '12.5em');
          t2.setAttribute('font-weight', 'bold');
        }
        if(i==2) {
          text.textContent = getMSG('system_memolife_09');
          text.setAttribute('x', '16.5em');
          text.setAttribute('y', '17em');
          t2.textContent = getMSG('system_memolife_10');
          t2.setAttribute('x', '16.5em');
          t2.setAttribute('y', '18em');
          t2.setAttribute('font-weight', 'bold');
        }
        if(i==3) {
          text.textContent = getMSG('system_memolife_11');
          text.setAttribute('x', '11em');
          text.setAttribute('y', '19em');
          text.setAttribute('fill', '#B68A16');
          t2.textContent = getMSG('system_memolife_12');
          t2.setAttribute('x', '11em');
          t2.setAttribute('y', '20em');
          t2.setAttribute('fill', '#B68A16');
          t2.setAttribute('font-weight', 'bold');
        }
        if(i==4) {
          text.textContent = getMSG('system_memolife_13');
          text.setAttribute('x', '5.5em');
          text.setAttribute('y', '17em');
          text.setAttribute('fill', '#B68A16');
          t2.textContent = getMSG('system_memolife_14');
          t2.setAttribute('x', '5.5em');
          t2.setAttribute('y', '18em');
          t2.setAttribute('fill', '#B68A16');
          t2.setAttribute('font-weight', 'bold');
        }
        if(i==5) {
          text.textContent =getMSG('system_memolife_15');
          text.setAttribute('x', '4em');
          text.setAttribute('y', '11.5em');
          text.setAttribute('fill', '#B68A16');
          t2.textContent = getMSG('system_memolife_16');
          t2.setAttribute('x', '4.5em');
          t2.setAttribute('y', '12.5em');
          t2.setAttribute('fill', '#B68A16');
          t2.setAttribute('font-weight', 'bold');
        }
        if(i==6) {
          text.textContent = getMSG('system_memolife_17');
          text.setAttribute('x', '7.5em');
          text.setAttribute('y', '6em');
          text.setAttribute('fill', '#B68A16');
          t2.textContent = getMSG('system_memolife_18');
          t2.setAttribute('x', '8em');
          t2.setAttribute('y', '7em');
          t2.setAttribute('fill', '#B68A16');
          t2.setAttribute('font-weight', 'bold');
        }
      }

      /* if(getID == "pieChart2"){
         if(i==0) {
         t3.textContent = "0";
         t3.setAttribute('x', '10em');
         t3.setAttribute('y', '5em');
         }
         if(i==1) {
         t3.textContent = "1";
         t3.setAttribute('x', '12em');
         t3.setAttribute('y', '6.5em');
         }
         if(i==2) {
         t3.textContent = "2";
         t3.setAttribute('x', '13em');
         t3.setAttribute('y', '9.3em');
         }
         if(i==3) {
         t3.textContent = "3";
         t3.setAttribute('x', '12em');
         t3.setAttribute('y', '12em');
         }
         if(i==4) {
         t3.textContent = "4";
         t3.setAttribute('x', '10em');
         t3.setAttribute('y', '14em');
         }
         if(i==5) {
         t3.textContent = "5";
         t3.setAttribute('x', '7em');
         t3.setAttribute('y', '14em');
         }
         if(i==6) {
         t3.textContent = "6";
         t3.setAttribute('x', '5em');
         t3.setAttribute('y', '12em');
         }
         if(i==7) {
         t3.textContent = "7";
         t3.setAttribute('x', '4em');
         t3.setAttribute('y', '9.3em');
         }
         if(i==8) {
         t3.textContent = "8";
         t3.setAttribute('x', '5em');
         t3.setAttribute('y', '6.5em');
         }
         if(i==9) {
         t3.textContent = "9";
         t3.setAttribute('x', '7em');
         t3.setAttribute('y', '5em');
         }
         } */


      if(getID == "pieChart"){
        $(text).appendTo($groups[i]);
        $(t2).appendTo($groups[i]);
      }

      /* if(getID == "pieChart2"){
         $(t3).appendTo($groups[i]);
         } */
    }

    settings.beforeDraw.call($this);
    //Animation start
    triggerAnimation();

    function pathMouseEnter(e){
      var index = $(this).data().order;
      // $tip.text(data[index].title + ": " + data[index].value).fadeIn(200);
      if ($groups[index][0].getAttribute("data-active") !== "active"){
        $lightPies[index].animate({opacity: .8}, 180);
      }
      settings.onPieMouseenter.apply($(this),[e,data]);
    }
    function pathMouseLeave(e){
      var index = $(this).data().order;
      // $tip.hide();
      if ($groups[index][0].getAttribute("data-active") !== "active"){
        $lightPies[index].animate({opacity: settings.lightPiesOpacity}, 100);
      }
      settings.onPieMouseleave.apply($(this),[e,data]);
    }
    function pathMouseMove(e){
      /* $tip.css({
         top: e.pageY + settings.tipOffsetY,
         left: e.pageX - $tip.width() / 2 + settings.tipOffsetX
         });*/
    }
    function pathClick(e){
      var index = $(this).data().order;
      var targetGroup = $groups[index][0];
      for (var i = 0, len = data.length; i < len; i++){
        if (i === index) continue;
        $groups[i][0].setAttribute("data-active","");
        $lightPies[i].css({opacity: settings.lightPiesOpacity});
      }
      if (targetGroup.getAttribute("data-active") === "active"){
        targetGroup.setAttribute("data-active","");
        $lightPies[index].css({opacity: .8});
      } else {
        targetGroup.setAttribute("data-active","active");
        $lightPies[index].css({opacity: 1});
      }
      settings.onPieClick.apply($(this),[e,data]);

	    if($(e.currentTarget).data('system') == 'singlesys') {
        showSysSinglePractice('singlesys', index);
	    } else {
		    showSysDoublePractice(null, index);
	    }

      translate();
    }
    function drawPieSegments (animationDecimal){
      var startRadius = -PI/2,//-90 degree
          rotateAnimation = 1;
      if (settings.animation) {
        rotateAnimation = animationDecimal;//count up between0~1
      }

      $pathGroup[0].setAttribute("opacity",animationDecimal);

      //draw each path
      for (var i = 0, len = data.length; i < len; i++){
        var segmentAngle = rotateAnimation * ((data[i].value/segmentTotal) * (PI*2)),//start radian
            endRadius = startRadius + segmentAngle,
            largeArc = ((endRadius - startRadius) % (PI * 2)) > PI ? 1 : 0,
            startX = centerX + cos(startRadius) * pieRadius,
            startY = centerY + sin(startRadius) * pieRadius,
            endX = centerX + cos(endRadius) * pieRadius,
            endY = centerY + sin(endRadius) * pieRadius,
            startX2 = centerX + cos(startRadius) * (pieRadius + settings.lightPiesOffset),
            startY2 = centerY + sin(startRadius) * (pieRadius + settings.lightPiesOffset),
            endX2 = centerX + cos(endRadius) * (pieRadius + settings.lightPiesOffset),
            endY2 = centerY + sin(endRadius) * (pieRadius + settings.lightPiesOffset);
        var cmd = [
          'M', startX, startY,//Move pointer
          'A', pieRadius, pieRadius, 0, largeArc, 1, endX, endY,//Draw outer arc path
          'L', centerX, centerY,//Draw line to the center.
          'Z'//Cloth path
        ];
        var cmd2 = [
          'M', startX2, startY2,
          'A', pieRadius + settings.lightPiesOffset, pieRadius + settings.lightPiesOffset, 0, largeArc, 1, endX2, endY2,//Draw outer arc path
          'L', centerX, centerY,
          'Z'
        ];
        $pies[i][0].setAttribute("d",cmd.join(' '));
        $lightPies[i][0].setAttribute("d", cmd2.join(' '));
        startRadius += segmentAngle;
      }
    }

    var animFrameAmount = (settings.animation)? 1/settings.animationSteps : 1,//if settings.animationSteps is 10, animFrameAmount is 0.1
        animCount =(settings.animation)? 0 : 1;
    function triggerAnimation(){
      if (settings.animation) {
        requestAnimFrame(animationLoop);
      } else {
        drawPieSegments(1);
      }
    }
    function animationLoop(){
      animCount += animFrameAmount;//animCount start from 0, after "settings.animationSteps"-times executed, animCount reaches 1.
      drawPieSegments(easingFunction(animCount));
      if (animCount < 1){
        requestAnimFrame(arguments.callee);
      } else {
        settings.afterDrawed.call($this);
      }
    }
    function Max(arr){
      return Math.max.apply(null, arr);
    }
    function Min(arr){
      return Math.min.apply(null, arr);
    }
    return $this;
  };
})(jQuery);
